import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const HOMEPAGE: AppRouteRecordRaw = {
  path: '/homePage',
  name: 'homePage',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '首页',
    icon: 'icon-file',
    order: 0,
    requiresAuth: true,
    hideInMenu: false,
  },
  children: [
    {
      path: 'index',
      name: '首页',
      component: () => import('@/views/homePage/index.vue'),
      meta: {
        locale: 'home',
        hideInMenu: false,
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};
export default HOMEPAGE;
